import UserInteractionLogger from "@shared/lib/analytics/internal/UserInteractionLogger";
import { getPublicPurchasePlatform } from "@shared/modules/basket/utils/basket-utils";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";
import { IBasket } from "@shared/modules/basket/interfaces/IBasket";
import { TicketBasket } from "@shared/modules/basket/types";
import {
  AnalyticsButtonClickData,
  AnalyticsPageViewData,
  AnalyticsViewContentData,
  BeginCheckoutParams,
} from "../AnalyticsService-types";
import { getCustomQuestionsParams } from "./getAdditionalParams";

/*
 * It might seem pointless to have this class but I created it so that the AnalyticsService
 * can just be concerned with calling the internal and external classes to do the work. It
 * helps to have a better separation of concerns.
 */
export class InternalAnalytics {
  viewContent = (data: AnalyticsViewContentData) => {
    return UserInteractionLogger.impression({
      ...data,
      capi_should_trigger: true,
      custom_params: {
        purchase_source_platform: getPublicPurchasePlatform(),
        ...data.custom_params,
      },
    });
  };

  /**
   * ANALYTICS FIX: New internal analytics method for view_item tracking
   *
   * Previously view_item events were not being tracked in internal analytics.
   * This method ensures proper funnel tracking when users view ticket types.
   */
  viewItems = (data: AnalyticsViewContentData) => {
    return UserInteractionLogger.impression({
      ...data,
      capi_should_trigger: false,
      custom_params: {
        purchase_source_platform: getPublicPurchasePlatform(),
        ...data.custom_params,
      },
    });
  };

  pageView = (data: AnalyticsPageViewData, routeUrl?: string) => {
    return UserInteractionLogger.pageView(
      {
        ...data,
        capi_should_trigger: true,
        custom_params: {
          purchase_source_platform: getPublicPurchasePlatform(),
          ...data.custom_params,
        },
      },
      routeUrl
    );
  };

  buttonClick = (data: AnalyticsButtonClickData) => {
    return UserInteractionLogger.buttonClick(data);
  };

  addToCart = (item: TicketItemGroupType, basket: IBasket | TicketBasket) => {
    return UserInteractionLogger.addToCart({
      item,
      basket,
    });
  };

  initiateCheckout = (params: BeginCheckoutParams) => {
    return UserInteractionLogger.initiateCheckout({
      basket: params.basket,
      additionalParams: {
        step: params.stepId,
        ...params.customParams,
        ...getCustomQuestionsParams(
          params.basket,
          params.stepId,
          params.forceGuestCheckout ?? false,
          params.hasGuestCheckout ?? false
        ),
      },
    });
  };
}
